// This function allow to reference all chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "static/css/" + {"2888":"2e8ca8656d4eaad6","5096":"e6c6a9caf0f28945","8893":"68891ddb699a42ce","9307":"e81304dab0bc8ab7"}[chunkId] + ".css";
};